import { graphql } from '@/generated/gql';

export const INTAKE_UPDATE_CHAT_SESSION_CURRENT_STEP = graphql(/* GraphQL */ `
  subscription OnChatSessionCurrentStep($id: UUID!) {
    sevenbridges {
      chatSession(id: $id) {
        id
        status
        createdBy
        demandId
        demandResponsibleUsers
        demandSequenceNumber
        currentStep {
          id
          status
          variant
          createdAt
          sequence
          role
          chatSessionId
        }
      }
    }
  }
`);
